import { Fragment } from 'react';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useTrackPendingPracticalExercises } from '../../tracks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MaybeLink = ({
  practicalExerciseId,
  practicalExerciseName,
  parentLessonId,
  trackId
}) => {
  if (parentLessonId) {
    const url = `/tracks/${trackId}/${parentLessonId}/${practicalExerciseId}`;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIRouterLink, {
        className: "lesson-content-item",
        "data-test-id": "lesson-content-item",
        to: url,
        children: practicalExerciseName
      })
    }, practicalExerciseId);
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: "practicalExerciseName"
  });
};
const PracticalExercisesOutstanding = ({
  trackId
}) => {
  const {
    pendingPracticalExercises
  } = useTrackPendingPracticalExercises(trackId.toString());
  return /*#__PURE__*/_jsx(Fragment, {
    children: (pendingPracticalExercises || []).map(practicalExercise => {
      return practicalExercise.parentLesson.graded && practicalExercise.graded && !practicalExercise.completed && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(MaybeLink, {
          parentLessonId: practicalExercise.parentLesson.id,
          practicalExerciseId: practicalExercise.id,
          practicalExerciseName: practicalExercise.name,
          trackId: trackId
        })
      }, practicalExercise.id);
    })
  });
};
export default PracticalExercisesOutstanding;